module.exports = __webpack_public_path__ + "static/img/qualifications_icon_08.97f12f6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/about/qualifications_icon_08.png
// module id = Ngxz
// module chunks = 3